<template>
  <kst-page-print-list pageFooter
    v-slot="{ title }"
    :catalog="SttrSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <List class="block" :dataList="dataList"/>
  </kst-page-print-list>
</template>

<script>
import Model from "../SttrModel.js";
import SttrSearchCatalog from "../SttrSearchCatalog.js";
import Services from "../../../services/Api/StockTrfServices.js";

import List from "./SttrPL_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    Model: Model,
    SttrSearchCatalog: SttrSearchCatalog,
    companyData: {},
    dataList: [],
    searchData: {
      Search: "",
      Date: null,
      DestinationWarehouseID: null,
      SourceWarehouseID: null
    }
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintListData(options);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.dataList = data.List;
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.dataList = [];
    },
    
    resetSearch() {
      this.searchData.Search = "";
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.DestinationWarehouseID =
        this.$kst.Search.OptionAll;
      this.searchData.SourceWarehouseID =
        this.$kst.Session.getDefaultWarehouseID();
    },

    getListOptions() {
      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        dstwarehouse: this.$kst.Search.getValue(
          this.searchData.DestinationWarehouseID),
        srcwarehouse: this.$kst.Search.getValue(
          this.searchData.SourceWarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields
      };
    }
  }
}
</script>